import { Injectable } from '@angular/core';
import { LogEvent } from '../enums/log-event';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class StateActionEventBufferService {
  private enabled = false;

  constructor(private logger: LoggerService) {}

  enable(): void {
    this.enabled = true;
  }

  disable(): void {
    this.enabled = false;
  }

  push(stateAction: {
    event: string;
    data: unknown;
    userId: string;
    attendanceSelectedId?: string;
  }): void {
    try {
      if (!this.enabled) return;

      this.logger.log(LogEvent.LIVECHAT_STATE_ACTION, {
        event: stateAction.event,
        data: stateAction.data,
        userId: stateAction.userId,
        attendanceSelectedId: stateAction.attendanceSelectedId,
      });
    } catch (error) {
      console.error(error);
    }
  }
}
